import React, { createContext, useContext, useEffect, useState } from "react";

// Auto-save status for the listing edit form (RC no-Save-button rule).
// RCListingForm provides { enabled, phase: "idle"|"saved"|"error", at, message };
// RCSection and FlowSection render <SectionSavedBadge /> at the bottom of their
// OPEN body — the accordions are single-open, so the note appears under the
// section the rep is actually editing. Own module (not RCListingForm) so
// FlowKit can consume it without an import cycle.
export const AutoSaveStatusContext = createContext(null);
export const useAutoSaveStatus = () => useContext(AutoSaveStatusContext);

export const SectionSavedBadge = () => {
  const status = useAutoSaveStatus();
  const [visible, setVisible] = useState(false);
  const at = status?.at;
  const phase = status?.phase;

  useEffect(() => {
    if (!at || phase === "idle") return undefined;
    setVisible(true);
    // "Saved" is a passing confirmation; an error stays until the next save
    // outcome replaces it (the next edit re-arms auto-save by itself).
    if (phase === "error") return undefined;
    const timer = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(timer);
  }, [at, phase]);

  if (!status?.enabled || !visible) return null;
  return (
    <div
      className={`rc-autosave-note${phase === "error" ? " rc-autosave-note--error" : ""}`}
      role="status"
      aria-live="polite"
    >
      {phase === "error" ? (status.message || "Couldn't save — check the highlighted fields.") : "Saved"}
    </div>
  );
};
